// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"366":"d2d4b017","453":"8df23d3d","723":"4f61b13f","769":"c20ed53f","807":"f2066d20"}[chunkId] + ".chunk.js";
};